var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Usage ex.")]), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<b-button variant=\"facebook\"><span>Facebook</span></b-button>")])]), _vm._v(" "), _c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"sm\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "facebook"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "twitter"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "linkedin"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "flickr"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "tumblr"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "xing"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "github"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "html5"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "openid"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "stack-overflow"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "css3"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "youtube"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dribbble"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "google-plus"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "instagram"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "pinterest"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vk"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "yahoo"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "behance"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dropbox"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "reddit"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "spotify"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vine"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "foursquare"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vimeo"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "variant": "facebook"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "twitter"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "linkedin"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "flickr"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "tumblr"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "xing"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "github"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "html5"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "openid"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "stack-overflow"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "css3"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "youtube"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dribbble"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "google-plus"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "instagram"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "pinterest"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vk"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "yahoo"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "behance"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dropbox"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "reddit"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "spotify"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vine"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "foursquare"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vimeo"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"lg\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "facebook"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "twitter"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "linkedin"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "flickr"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "tumblr"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "xing"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "github"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "html5"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "openid"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "stack-overflow"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "css3"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "youtube"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dribbble"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "google-plus"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "instagram"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "pinterest"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vk"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "yahoo"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "behance"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dropbox"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "reddit"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "spotify"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vine"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "foursquare"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vimeo"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Only icons. Usage ex.")]), _vm._v(" "), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<b-button variant=\"facebook icon\"><span>Facebook</span></b-button>")])]), _vm._v(" "), _c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"sm\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "facebook icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "twitter icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "linkedin icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "flickr icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "tumblr icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "xing icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "github icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "html5 icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "openid icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "stack-overflow icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "css3 icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "youtube icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dribbble icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "google-plus icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "instagram icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "pinterest icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vk icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "yahoo icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "behance icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dropbox icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "reddit icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "spotify icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vine icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "foursquare icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vimeo icon"
    }
  })], 1), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "variant": "facebook icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "twitter icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "linkedin icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "flickr icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "tumblr icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "xing icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "github icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "html5 icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "openid icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "stack-overflow icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "css3 icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "youtube icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dribbble icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "google-plus icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "instagram icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "pinterest icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vk icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "yahoo icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "behance icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dropbox icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "reddit icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "spotify icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vine icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "foursquare icon"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vimeo icon"
    }
  })], 1), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"lg\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "facebook icon"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "twitter icon"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "linkedin icon"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "flickr icon"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "tumblr icon"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "xing icon"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "github icon"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "html5 icon"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "openid icon"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "stack-overflow icon"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "css3 icon"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "youtube icon"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dribbble icon"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "google-plus icon"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "instagram icon"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "pinterest icon"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vk icon"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "yahoo icon"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "behance icon"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dropbox icon"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "reddit icon"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "spotify icon"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vine icon"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "foursquare icon"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vimeo icon"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Only text. Usage ex.")]), _vm._v(" "), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<b-button variant=\"facebook text\"><span>Facebook</span></b-button>")])]), _vm._v(" "), _c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"sm\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "facebook text"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "twitter text"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "linkedin text"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "flickr text"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "tumblr text"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "xing text"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "github text"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "html5 text"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "openid text"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "stack-overflow text"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "css3 text"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "youtube text"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dribbble text"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "google-plus text"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "instagram text"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "pinterest text"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vk text"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "yahoo text"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "behance text"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "dropbox text"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "reddit text"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "spotify text"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vine text"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "foursquare text"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "vimeo text"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "variant": "facebook text"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "twitter text"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "linkedin text"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "flickr text"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "tumblr text"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "xing text"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "github text"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "html5 text"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "openid text"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "stack-overflow text"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "css3 text"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "youtube text"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dribbble text"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "google-plus text"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "instagram text"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "pinterest text"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vk text"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "yahoo text"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "behance text"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "dropbox text"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "reddit text"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "spotify text"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vine text"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "foursquare text"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "vimeo text"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"lg\"")])])]), _vm._v(" "), _c('p', [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "facebook text"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "twitter text"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "linkedin text"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "flickr text"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "tumblr text"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "xing text"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "github text"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "html5 text"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "openid text"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "stack-overflow text"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "css3 text"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "youtube text"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dribbble text"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "google-plus text"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "instagram text"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "pinterest text"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vk text"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "yahoo text"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "behance text"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "dropbox text"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "reddit text"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "spotify text"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vine text"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "foursquare text"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "vimeo text"
    }
  }, [_c('span', [_vm._v("Vimeo")])])], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de600f26","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SocialButtons.vue
// module id = 961
// module chunks = 1